import EventRemoveMapper from './event-remove-mapper';

const EventRemoveModel = {
    mapper: EventRemoveMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },

    outright: {
        fieldName: 'o',
        type: Boolean,
    },
};

export default EventRemoveModel;
